
/* eslint-disable @typescript-eslint/camelcase */
import {
  formatDateNormal,
  formatPriceRP,
  parsingErrorResponse,
  CLIENT_ERROR
} from "@/app/infrastructures/misc/Utils";
import EmptyList from "@/app/ui/components/empty-list/index.vue";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { KulionerController } from "@/app/ui/controllers/KulionerController";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { LocationController } from "@/app/ui/controllers/LocationController";
import { ShipmentBookingController } from "@/app/ui/controllers/ShipmentBookingController";
import { ShipmentInstantBooking } from "@/data/payload/api/ShipmentBookingRequest";
import { PrintDataEntitas, ShipmentId } from "@/domain/entities/Booking";
import { KulionerMerchant, KulionerOrder } from "@/domain/entities/Kulioner";
import { ResponsePayload } from "@/domain/entities/ResponsePayload";
import { Options, Vue } from "vue-class-component";
import ModalSuccessProcessOrder from "../components/modal-success-process-order.vue";
import { ErrorMessageEntities } from "@/domain/entities/MainApp";
import generatePrintReceipt from "../components/receipt";
import ModalProcessKulioner from "../components/ModalProcessKulioner.vue";
import PaginationV3 from "@/app/ui/components/pagination-v3/index.vue";
import { ORDER_STATUS } from "../utils";
import HistoryOrder from "./components/history-order.vue";
import generateKulionerBulkLabelResiThermal from "../modules/kulioner-bulk-label-resi-thermal";
import JsBarcode from "jsbarcode";
import Badge from "primevue/badge";

@Options({
  components: {
    PaginationV3,
    EmptyList,
    ModalSuccessProcessOrder,
    ModalProcessKulioner,
    HistoryOrder,
    Badge
  }
})
class KulionerDetail extends Vue {
  successProcessResponse = new ResponsePayload();
  isShowSuccessProcessModal = false;
  formatPriceRP = formatPriceRP;
  formatDateNormal = formatDateNormal;
  isShowModalProcessKulioner = false;
  isShowModalAcceptOrder = false;
  isShowModalFailedOrder = false;

  detailData = new KulionerOrder();
  isLoading = false;
  isError = false;
  errorCause: any = "";
  isLoadingSubmitBtn = false;
  isExpanded = true;

  buttonActionError = {
    textColor: "white",
    title: "Muat ulang",
    iconLeft: "ics_o_reload"
  };
  sttId = 0;

  // Get Data
  created() {
    this.getDetail();
    this.getCycleList();
  }

  // route navigation
  goBack() {
    this.$router.push("/kulioner");
  }

  // close modal accept order
  closeModalSuccess() {
    this.$emit("successProcessOrder");
    this.getDetail();
  }

  // success modal accept order
  onSuccess() {
    this.closeModalOrderKulioner();
    this.isShowModalAcceptOrder = true;
  }

  // failed modal accept order
  onFailed() {
    this.closeModalOrderKulioner();
    this.isShowModalFailedOrder = true;
  }

  // close modal order
  closeModalOrderKulioner() {
    this.isShowModalProcessKulioner = false;
  }

  isExpandDetail(index: number) {
    return this.detailData.merchants[index].isExpandDetailKulioner;
  }

  get id(): number {
    return Number(this.$route.params.id);
  }

  setExpand(index: number) {
    this.detailData.merchants[
      index
    ].isExpandDetailKulioner = !this.isExpandDetail(index);
  }

  products(index: number) {
    return this.detailData.merchants[index].products;
  }

  get merchants() {
    return this.detailData.merchants;
  }

  async getDetail() {
    this.isLoading = true;
    this.isError = false;
    this.errorCause = "";
    try {
      const resp = await KulionerController.getKulionerDetail(this.id);
      this.detailData = resp;
    } catch (error) {
      this.isError = true;
      this.errorCause = error;
    } finally {
      this.isLoading = false;
    }
  }

  censorPhoneLastFour = (num: number | string): string => {
    const str = typeof num === "number" ? num.toString() : num;

    if (str.length <= 4) return "*".repeat(str.length);

    const visiblePart = str.slice(0, -4);
    const censoredPart = "****";

    return visiblePart + censoredPart;
  };
  mapStatusLabel(
    item: string,
    customLabels?: { [key: string]: string }
  ): string {
    const baseLabels = {
      ordwtc: "Pesanan baru",
      ordprc: "Pesanan diproses",
      ordbkd: "Pesanan perlu dikirim",
      orddlv: "Pesanan dikirim",
      cncwrf: "Pesanan dibatalkan",
      ordrcv: "Pesanan selesai"
    };

    const mergedLabels = { ...baseLabels, ...customLabels };
    const status = item.toLowerCase() as keyof typeof mergedLabels;
    return mergedLabels[status] || item;
  }

  getStatusOrder(status: string) {
    return ORDER_STATUS(status);
  }

  get filteredHistorries() {
    return this.detailData.histories.sort(
      (a, b) =>
        new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
    );
  }

  get deliveryStatusStyling() {
    const status = this.detailData.status.toLowerCase();
    const backgorund: any = () => {
      const obj = {
        ordwtc: "bg-yellow-lp-400 border-yellow-lp-100",
        ordprc: "bg-blue-lp-600 border-blue-lp-500",
        ordbkd: "bg-aqua-lp-200 border-aqua-lp-300",
        orddlv: "bg-purple-lp-100 border-purple-lp-900",
        ordrcv: "bg-green-lp-500 border-green-lp-200",
        cncwrf: "bg-red-lp-1100 border-red-lp-100"
      } as any;
      return obj[status] ?? "bg-yellow-lp-400 border-yellow-lp-100";
    };
    const label: any = () => {
      const obj = {
        ordwtc: "text-yellow-lp-500",
        ordprc: "text-blue-lp-700",
        ordbkd: "text-aqua-lp-900",
        orddlv: "text-purple-lp-700",
        ordrcv: "text-green-lp-400",
        cncwrf: "text-red-lp-1600"
      } as any;
      return obj[status] ?? "text-yellow-lp-500";
    };
    const value: any = () => {
      const obj = {
        ordwtc: "text-yellow-lp-100",
        ordprc: "text-blue-lp-500",
        ordbkd: "text-aqua-lp-300",
        orddlv: "text-purple-lp-900",
        ordrcv: "text-green-lp-200",
        cncwrf: "text-red-lp-100"
      } as any;
      return obj[status] ?? "text-yellow-lp-100";
    };
    return {
      background: backgorund(),
      label: label(),
      value: value()
    };
  }

  get buttonTitle() {
    const buttonText: any = () => {
      const obj = {
        ordwtc: "Terima pesanan",
        ordprc: "Proses pengiriman",
        ordbkd: "Lacak pengiriman",
        orddlv: "Lacak pengiriman",
      } as any;
      return obj[this.detailData.status.toLowerCase()] ?? "";
    };
    return buttonText()
  }

  get buttonId() {
    return this.detailData.status.toLowerCase() === "ordwtc"
      ? "button_accept_order_detail_kulioner"
      : "button_process_order_detail_kulioner";
  }

  get deliveryStatusBackgroundColor() {
    const status = this.detailData.status.toLowerCase();
    const top: any = () => {
      const obj = {
        ordwtc: "#FAB713",
        ordprc: "#2468F6",
        ordbkd: "#51B6D5",
        orddlv: "#6257BA",
        ordrcv: "#7ACB90",
        cncwrf: "#E13E49"
      } as any;
      return obj[status] ?? "text-yellow-lp-500";
    };
    const bottom: any = () => {
      const obj = {
        ordwtc: "#FAB713",
        ordprc: "#2468F6",
        ordbkd: "#51B6D5",
        orddlv: "#6257BA",
        ordrcv: "#00875A",
        cncwrf: "#B82025"
      } as any;
      return obj[status] ?? "text-yellow-lp-100";
    };
    return {
      top: top(),
      bottom: bottom()
    };
  }

  get showPrintReceipt(): boolean {
    return ["ORDBKD", "ORDDLV", "ORDRCV"].includes(this.detailData.status);
  }
  isLoadingPrintReceipt = false;

  listStt: PrintDataEntitas[] = [];
  
  async getDetailStt(sttNo: string) {
    try {
      const listStt = await KulionerController.getListStt({
        page: 1,
        limit: 50,
        destinationCityId: 0,
        userType: "",
        bookedBy: "",
        bookedType: "",
        fromDate: "",
        endDate: "",
        sttNumber: sttNo
      });

      const listOrder = await KulionerController.getKulionerDetail(
        this.id
      );

      this.listStt = [
        new PrintDataEntitas({
          ...listStt[0],
          orderDetail: listOrder
        })
      ]
    } catch (err) {
      MainAppController.showErrorMessage(
        parsingErrorResponse(err, "Gagal Print resi!")
      );
      throw err;
    }
  }

  async printBulkReceipt() {
    const listBulkStt: PrintDataEntitas[] = await this.generateDataResi();
    if (!listBulkStt.length) return;

    new Promise(function(resolve) {
      MainAppController.showLoading();
      setTimeout(resolve.bind(null, null), 1);
    }).then(() => {
      const accountType = AccountController.accountData.account_type;
      generateKulionerBulkLabelResiThermal({
        data: listBulkStt,
        accountType
      });

      MainAppController.closeLoading();
    });
  }

  async generateDataResi() {
    const list: PrintDataEntitas[] = [];

    await new Promise((resolve) => {
      this.listStt.forEach((item, index) => {
        if (item) {
          const barcode = document.createElement("img");
          const vendorBarcode = document.createElement("img");
          JsBarcode(barcode, item.sttNo, {
            textAlign: "left",
            displayValue: false,
            fontSize: 16
          });
          if (item.sttVendorRefferenceNo) {
            // vendor ref code
            JsBarcode(vendorBarcode, item.sttVendorRefferenceNo, {
              textAlign: "left",
              displayValue: false,
              fontSize: 16
            });
          }

          item.sttPieces.forEach((e) => {
            list.push(
              new PrintDataEntitas({
                ...e,
                ...item,
                barcode: barcode.src,
                vendorRefCode: vendorBarcode.src
              })
            );
          });

          barcode.remove();
          vendorBarcode.remove();
        }

        if (this.listStt.length - 1 === index) {
          resolve(true);
        }
      });
    });

    return list;
  }

  async onPrintReceipt(sttNo: string) {
    try {
      this.isLoadingPrintReceipt = true;
      MainAppController.showLoading();
      await this.getDetailStt(sttNo);
      await this.printBulkReceipt();
    } finally {
      this.isLoadingPrintReceipt = false;
      MainAppController.closeLoading();
    }
  }

  get errorData() {
    const error = this.errorCause?.response ? "server" : "internet";
    const icon = error === "server" ? "error-token-ngen" : "error-internet";
    const header =
      error === "server"
        ? "Terjadi gangguan sistem"
        : "Jaringan internet terputus";
    const message =
      error === "server"
        ? `Klik "Muat ulang" atau coba beberapa saat lagi.`
        : `Periksa jaringan internal Anda lalu klik "Muat ulang".`;
    return { icon: icon, header: header, message: message };
  }

  async onProcessOrder() {
    if (this.isLoadingSubmitBtn) return;
    if (this.detailData.orderShipmentId.startsWith("AD")) {
      try {
        MainAppController.showLoading();
        this.isLoadingSubmitBtn = true;
        const res = await KulionerController.getShipmentIdList(
          this.detailData.orderShipmentId
        );
        this.addShipmentToBook(res.data);
      } catch (err) {
        MainAppController.closeLoading();
        this._showErrorProccessOrder(err);
        this.isLoadingSubmitBtn = false;
      }
    }
  }

  addShipmentToBook(data: any, type = "non-kr") {
    if (data.length > 0) {
      for (const row of data) {
        this.onProcessBook(row);
      }
      return;
    }
  }

  async onProcessBook(detail: ShipmentId) {
    this.addInstantBooking(detail);
  }

  get originDistrict() {
    const detail = LocationController.districtDetail;
    return {
      id: detail.id,
      name: `${detail.name}, ${detail.cityName}`,
      code: `${detail.code}`,
      cityCode: `${detail.cityCode}`,
      ursaCode: detail.ursaCode,
      cityId: detail.cityId,
      cityName: detail.cityName
    };
  }

  get dataProfile() {
    return AccountController.accountData;
  }

  mappingSttPieces(shipment: any) {
    return shipment.shipmentGoodDetail.length
      ? shipment.shipmentGoodDetail.map((pieces: any) => ({
          stt_piece_length: pieces.shipment_goods_length,
          stt_piece_width: pieces.shipment_goods_width,
          stt_piece_height: pieces.shipment_goods_height,
          stt_piece_gross_weight: pieces.shipment_goods_weight
        }))
      : [];
  }

  payloadSttOne(shipment: ShipmentId) {
    return {
      sttNo: "",
      sttShipmentId: shipment.shipmentAlgoId,
      sttTaxNumber: "",
      sttGoodsEstimatePrice: shipment.shipmentGoodsPriceEstimation,
      sttGoodsStatus: shipment.shipmentGoodsStatus,
      sttNoRefExternal: shipment.shipmentBookingId.startsWith("TSLP")
        ? shipment.shipmentBookingId
        : "",
      sttOriginCityId: this.originDistrict.cityCode,
      sttDestinationCityId: shipment.shipmentDestinationCity?.code,
      sttOriginDistrictId: this.originDistrict.code
    };
  }

  payloadSttTwo(shipment: ShipmentId) {
    return {
      sttDestinationDistrictId: shipment.shipmentDestinationDistrict?.code,
      sttSenderName: shipment.shipmentSenderName,
      sttSenderPhone: shipment.senderPhoneInstantBooking,
      sttSenderAddress: shipment.shipmentSenderAddress,
      sttRecipientName: shipment.shipmentRecipientName,
      sttRecipientPhone: shipment.recipientPhoneInstantBooking,
      sttRecipientAddress: shipment.shipmentRecipientAddress,
      sttProductType: shipment.shipmentProduct,
      sttCommodityCode: shipment.shipmentCommodityCode || "GEN",
      sttInsuranceType: shipment.shipmentInsurance
    };
  }

  payloadSttThree(shipment: ShipmentId) {
    return {
      sttIsDo: shipment.isDO,
      sttIsCod: shipment.shipmentIsCod,
      sttIsDfod: shipment.shipmentIsDfod,
      sttCodFee: shipment.codFee,
      sttCodAmount: shipment.codAmount,
      sttPieces: this.mappingSttPieces(shipment),
      postalCodeDestination: shipment.postalCodeDestination,
      addressReceiverType: "home",
      sttWoodpacking: shipment.shipmentIsWoodpacking,
      sttAttachFiles: [],
      sttRecipientEmail: "",
      sttKtpImage: "",
      sttTaxImage: "",
      sttInterTaxNumber: "",
      sttIdentityNumber: "",
      sttCipl: []
    };
  }

  mappingPayloadStt(shipment: any) {
    return {
      ...this.payloadSttOne(shipment),
      ...this.payloadSttTwo(shipment),
      ...this.payloadSttThree(shipment)
    };
  }

  async addInstantBooking(shipment: ShipmentId) {
    const accountTypeDetail = this.dataProfile.account_type_detail || {};
    await ShipmentBookingController.addInstantBooking(
      new ShipmentInstantBooking({
        shipmentPackageId: shipment.shipmentPacketId,
        stt: this.mappingPayloadStt(shipment),
        districtOrigin: {
          id: this.originDistrict.id,
          code: this.originDistrict.code,
          name: this.originDistrict.name,
          ursaCode: this.originDistrict.ursaCode,
          city: {
            id: this.originDistrict.cityId,
            code: this.originDistrict.cityCode,
            name: this.originDistrict.cityName
          }
        },
        districtDestination: {
          id: shipment.shipmentDestinationDistrict.id,
          code: shipment.shipmentDestinationDistrict.code,
          name: shipment.shipmentDestinationDistrict.name,
          ursaCode: shipment.shipmentDestinationDistrict.ursa_code,
          isCod: "",
          status: "",
          type: "",
          city: {
            id: shipment.shipmentDestinationCity.id,
            code: shipment.shipmentDestinationCity.code,
            name: shipment.shipmentDestinationCity.name
          }
        },
        commodity: {
          commodityId: shipment.shipmentCommodityId,
          commodityCode: shipment.shipmentCommodityCode,
          commodityName: shipment.shipmentCommodityName,
          commodityDocumentSurcharge:
            shipment.shipmentCommodityDocumentSurcharge,
          hsCode: shipment.shipmentCommodityHsCode
        },
        partner: {
          id: accountTypeDetail.id,
          name: accountTypeDetail.company_name,
          code: accountTypeDetail.code,
          partnerExternalCode: this.dataProfile.account_type_detail
            ?.partnerExternalCode,
          partnerLocation: {
            id: accountTypeDetail.partnerLocation?.id,
            districtCode: accountTypeDetail.partnerLocation?.district_code
          },
          partnerLocationList: []
        }
      })
    )
      .then((res: ResponsePayload) => {
        // open modal success
        this.successProcessResponse = res;
        this.isShowSuccessProcessModal = true;
      })
      .catch((error: any) => {
        // open modal error
        this._showErrorProccessOrder(error);
      })
      .finally(() => {
        this.isLoadingSubmitBtn = false;
        MainAppController.closeLoading();
      });
  }

  _showErrorProccessOrder(error: any) {
    MainAppController.showErrorMessage(
      new ErrorMessageEntities({
        title: "Booking gagal",
        message: error.response.data?.message?.id || "",
        type: CLIENT_ERROR,
        buttonSuccessText: "Oke, mengerti",
        onClose: () => {
          MainAppController.closeErrorMessage();
        }
      })
    );
  }

  onButtonClick() {
    switch (this.detailData.status.toLowerCase()) {
      case "ordwtc":
        this.isShowModalProcessKulioner = true;
        break;
      case "ordprc":
        if (this.isAllMerchantPurchased) {
          this.onProcessOrder();
        } else {
          MainAppController.showErrorMessage(
            new ErrorMessageEntities({
              title: "Gagal memproses pengiriman",
              message: "Silakan update semua pesanan terlebih dahulu",
              type: CLIENT_ERROR,
              buttonSuccessText: "Update pesanan",
              onClose: () => {
                MainAppController.closeErrorMessage();
              }
            })
          );
        }
        break;
      case "ordbkd":
      case "orddlv":
        this.onTrackingOrder();
        break;
      default:
        break;
    }
  }

  isLoadingDownloadOrder = false;
  async onDownloadOrder() {
    this.isLoadingDownloadOrder = true;
    // action download order
    await generatePrintReceipt([this.detailData]);
    this.isLoadingDownloadOrder = false;
  }

  onTrackingOrder() {
    window.open(`/shipment/tracking/stt?stt-no=${this.detailData.orderSttNo}`);
  }

  get cycleData() {
    if (!this.detailData.cycleAt) {
      return "-";
    }
    const time = this.detailData.cycleAt;
    const [hour, minute] = time.split(":");
    const result = `${hour}:${minute}`;
    return "Cycle " + result;
  }

  get buttonTitleUpdate() {
    const buttonText: any = () => {
      const obj = {
        ordprc: "Update Pesanan"
      } as any;
      return obj[this.detailData.status.toLowerCase()] ?? "";
    };
    return buttonText();
  }
  updateOrder() {
    // update order
    this.$router.push(`/kulioner/merchant/cycle/${this.detailData.cycleAt}`);
  }
  getBadgeStatus(item: KulionerMerchant): { label: string; severity: string } {
    if (!this.getMerchantSummary(item).allPurchased) {
      return {
        label: "Belum dibeli",
        severity: "info"
      };
    }

    if (this.getMerchantSummary(item).allPurchased && this.getMerchantSummary(item).totalActualQuantity && this.getMerchantSummary(item).totalActualQuantity < this.getMerchantSummary(item).totalQuantity) {
      return {
        label: `Sudah dibeli ${this.getMerchantSummary(item).totalActualQuantity}/${this.getMerchantSummary(item).totalQuantity}`,
        severity: "warning"
      };
    }
    if (this.getMerchantSummary(item).allPurchased && this.getMerchantSummary(item).totalActualQuantity && this.getMerchantSummary(item).totalActualQuantity === this.getMerchantSummary(item).totalQuantity) {
      return {
        label: `Sudah dibeli ${this.getMerchantSummary(item).totalActualQuantity}/${this.getMerchantSummary(item).totalQuantity}`,
        severity: "success"
      };
    }

    return {
      label: "Stok habis",
      severity: "danger"
    };
  }

  getMerchantSummary(merchant: KulionerMerchant) {
    const products = merchant.products ?? [];

    const totalActualQuantity = products.reduce(
      (acc, p) => acc + (p.actualQuantity ?? 0),
      0
    );

    const totalQuantity = products.reduce(
      (acc, p) => acc + (p.quantity ?? 0),
      0
    );

    const allPurchased = products.every(p => p.isPurchased === true);

    return {
      totalActualQuantity,
      totalQuantity,
      allPurchased
    };
  }

  mapCycleTime(time: string) {
    const [hour, minute] = time ? time.split(":") : "";
    const formattedTime = `Cycle ${hour}.${minute}`;
    const label = time ? formattedTime : "-";
    const textColor = [
      "#CD4425",
      "#4D4D4D",
      "#2468F6",
      "#FAB713",
      "#51B6D5",
      "#6257BA",
      "#36B37E",
      "#B53783"
    ]
    const backgroundColor = [
      "#FCECE7",
      "#EBECF0",
      "#D8EEFB",
      "#FEFAE8",
      "#EAFCFF",
      "#E9E7FD",
      "#E3FCEF",
      "#FFC8E9"
    ]
    const colorIndex = this.cycleList.findIndex((cycle) => cycle.cutOffTime === time);
    return {
      label: label,
      color: colorIndex >= textColor.length ? "#4D4D4D" : textColor[colorIndex],
      background: colorIndex >= backgroundColor.length ? "#EBECF0" : backgroundColor[colorIndex]
    }
  }
  hashCode(str: string) {
    let hash = 5381; // DJB2 hash initial value
    for (let i = 0; i < str.length; i++) {
      const char = str.charCodeAt(i);
      // DJB2 hash algorithm with position sensitivity
      hash = ((hash * 33) + char + i) >>> 0; // >>> 0 ensures unsigned 32-bit integer
    }
    return hash;
  }

  get isAllMerchantPurchased() {
    return this.detailData.merchants
    ?.flatMap(merchant => merchant.products ?? [])
    .every(product => product.isPurchased === true) ?? false;
  }

  sumTotalItemProduct() {
    return this.detailData.merchants?.reduce((acc, item) => acc + item.actualQuantity, 0);
  }

  get disableProcessOrderByCustomer() {
    const validProduct = this.merchants.some((merchant: KulionerMerchant) => {
      return merchant.products.every((product) => !product.isPurchased)
    })

    const allIsOutofStock = this.merchants.every((merchant: KulionerMerchant) => {
      return merchant.products.every((product) => product.actualQuantity === 0)
    })
    return (validProduct || allIsOutofStock) && this.buttonTitle === "Proses pengiriman";
  }

  get cycleList() {
    return KulionerController.cycles;
  }

  async getCycleList() {
    try {
      MainAppController.showLoading();
      await KulionerController.getCycleList();
    } finally {
      MainAppController.closeLoading();
    }
  }

  get disableUpdateOrderByCustomer() {
    return this.merchants.some((merchant: KulionerMerchant) => 
      merchant.products.every((product) => product.quantityUpdatedAt)
    )
  }
}
export default KulionerDetail;
